import Modal from 'react-bootstrap/Modal';
import './modal.scss'
import { useTranslation } from 'react-i18next';

const ModalComponent = (props: { showModal: boolean, textDel: string, onClickYes: (e: any) => void, onClickNo: (e: any) => void }) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal show={props.showModal} keyboard={false} backdrop={'static'} centered>
                <Modal.Header className="position-relative d-block modalThemeHeader">
                    <p className="modal-title-custom m-0 text-start text-lg-center">{props.textDel}</p>
                </Modal.Header>
                <Modal.Footer className='position-relative d-block text-center'>
                    <button className='btn-Custom btn-IDGrey' onClick={props.onClickNo}>{t("Cancel")}</button>
                    <button className='btn-Custom btn-IDRed' onClick={props.onClickYes}>{t("Delete")}</button>
                </Modal.Footer>
            </Modal>
        </>
    )

}
export default ModalComponent